import { render, staticRenderFns } from "./moreFGLG.vue?vue&type=template&id=09252b7a&lang=pug&"
import script from "./moreFGLG.vue?vue&type=script&lang=js&"
export * from "./moreFGLG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports